import { Component } from "@angular/core";

@Component({
  selector: "app-ownership-conversion-fee-calculation-request",
  templateUrl: "./ownership-conversion-fee-calculation-request.component.html",
  standalone: false,
})
export class OwnershipConversionFeeCalculationRequestComponent {}
